export const PermissionsResource = {
  name: "Permissions",
  path: "/user-management/permissions",
  access: ["Permissions", "read-permissions"],
};
